import { useState } from "react";
import api from "@/lib/api";

/**
 * Modal per creare un alunno fittizio nel database, usato per testare il portale Alunni.
 * Spostato dalla pagina Segremat ad Admin (richiesta utente).
 */
export default function TestAlunnoModal({ onClose, onCreated, defaultAnno }) {
  const [cf, setCf] = useState("FLGLNZ63B19B157C");
  const [cog, setCog] = useState("FOLEGATI");
  const [nom, setNom] = useState("LORENZO");
  const [anno, setAnno] = useState(defaultAnno || 2026);
  const [settore, setSettore] = useState("E");
  const [classe, setClasse] = useState("3A");
  const [nasDat, setNasDat] = useState("19/02/1963");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);
  const [ok, setOk] = useState(null);
  const submit = async () => {
    if (cf.length !== 16) { setErr("Codice fiscale deve essere di 16 caratteri"); return; }
    setSaving(true); setErr(null);
    try {
      const r = await api.post("/alunni-portal/admin/test-alunno", {
        cod_fis: cf.toUpperCase(), cog: cog.toUpperCase(), nom: nom.toUpperCase(),
        anno: parseInt(anno, 10), settore, classe: classe.toUpperCase(), nas_dat: nasDat,
      });
      setOk(r.data);
      if (onCreated) onCreated(r.data);
    } catch (e) {
      setErr(e.response?.data?.detail || "Errore creazione alunno di test");
    } finally { setSaving(false); }
  };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: "white", border: "1px solid #ccc", borderRadius: 6, width: 540, maxWidth: "100%", boxShadow: "0 12px 40px rgba(0,0,0,0.3)" }}>
        <div style={{ background: "#8e24aa", color: "white", padding: "12px 18px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <strong>🧪 Crea Alunno di Test (Portale Alunni)</strong>
          <button onClick={onClose} data-testid="test-alunno-close" style={{ background: "none", border: "none", color: "white", cursor: "pointer", fontSize: 18 }}>✕</button>
        </div>
        <div style={{ padding: 20 }}>
          <div style={{ fontSize: 11, color: "#666", marginBottom: 16, lineHeight: 1.5, background: "#fff3e0", border: "1px solid #ffb74d", padding: 10, borderRadius: 4 }}>
            ⚠️ Crea un alunno fittizio nel database per testare il flusso di iscrizione dal portale Alunni.
            L&apos;alunno avrà <code>_test_alunno=true</code>, classe esistente o creata al volo, e nessun genitore collegato.
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={{ fontSize: 11, color: "#666", fontWeight: 700 }}>Codice Fiscale *</label>
              <input value={cf} onChange={e => setCf(e.target.value.toUpperCase())} maxLength={16}
                data-testid="test-alunno-cf"
                style={{ width: "100%", padding: 8, fontSize: 13, fontFamily: "Consolas, monospace", letterSpacing: 1, border: "2px solid #8e24aa", borderRadius: 3 }} />
            </div>
            <div>
              <label style={{ fontSize: 11, color: "#666", fontWeight: 700 }}>Anno scolastico</label>
              <input type="number" value={anno} onChange={e => setAnno(e.target.value)}
                data-testid="test-alunno-anno"
                style={{ width: "100%", padding: 8, fontSize: 13, border: "1px solid #ccc", borderRadius: 3 }} />
            </div>
            <div>
              <label style={{ fontSize: 11, color: "#666", fontWeight: 700 }}>Cognome</label>
              <input value={cog} onChange={e => setCog(e.target.value.toUpperCase())} data-testid="test-alunno-cog"
                style={{ width: "100%", padding: 8, fontSize: 13, border: "1px solid #ccc", borderRadius: 3 }} />
            </div>
            <div>
              <label style={{ fontSize: 11, color: "#666", fontWeight: 700 }}>Nome</label>
              <input value={nom} onChange={e => setNom(e.target.value.toUpperCase())} data-testid="test-alunno-nom"
                style={{ width: "100%", padding: 8, fontSize: 13, border: "1px solid #ccc", borderRadius: 3 }} />
            </div>
            <div>
              <label style={{ fontSize: 11, color: "#666", fontWeight: 700 }}>Settore</label>
              <select value={settore} onChange={e => setSettore(e.target.value)} data-testid="test-alunno-settore"
                style={{ width: "100%", padding: 8, fontSize: 13, border: "1px solid #ccc", borderRadius: 3 }}>
                <option value="A">A · Infanzia</option>
                <option value="E">E · Primaria E</option>
                <option value="F">F · Primaria F</option>
                <option value="M">M · Secondaria</option>
              </select>
            </div>
            <div>
              <label style={{ fontSize: 11, color: "#666", fontWeight: 700 }}>Classe (es. 3A)</label>
              <input value={classe} onChange={e => setClasse(e.target.value.toUpperCase())} data-testid="test-alunno-classe"
                style={{ width: "100%", padding: 8, fontSize: 13, border: "1px solid #ccc", borderRadius: 3 }} />
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={{ fontSize: 11, color: "#666", fontWeight: 700 }}>Data nascita (GG/MM/AAAA)</label>
              <input value={nasDat} onChange={e => setNasDat(e.target.value)} data-testid="test-alunno-nasdat"
                style={{ width: "100%", padding: 8, fontSize: 13, border: "1px solid #ccc", borderRadius: 3 }} />
            </div>
          </div>
          {err && <div style={{ marginTop: 12, padding: 10, background: "#fff0f0", color: "#c00", border: "1px solid #fcc", borderRadius: 3, fontSize: 12 }}>{err}</div>}
          {ok && (
            <div style={{ marginTop: 12, padding: 12, background: "#e8f5e9", color: "#1b5e20", border: "1px solid #81c784", borderRadius: 3, fontSize: 12 }}>
              <div style={{ fontWeight: 700 }}>✓ Alunno creato (Cod {ok.alunno_cod})</div>
              <div style={{ marginTop: 6 }}>{ok.messaggio}</div>
            </div>
          )}
          <div style={{ marginTop: 16, display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button onClick={onClose} data-testid="test-alunno-cancel"
              style={{ padding: "8px 16px", background: "white", color: "#666", border: "1px solid #ccc", cursor: "pointer", borderRadius: 3, fontSize: 12, fontWeight: 700 }}>
              Chiudi
            </button>
            <button onClick={submit} disabled={saving} data-testid="test-alunno-submit"
              style={{ padding: "8px 18px", background: saving ? "#bbb" : "#8e24aa", color: "white", border: "none", cursor: saving ? "wait" : "pointer", borderRadius: 3, fontSize: 12, fontWeight: 700 }}>
              {saving ? "Creazione..." : (ok ? "✓ Crea/aggiorna ancora" : "Crea alunno di test")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
